<template>

  <b-row>

    <b-col lg="5" md="6">
       <auto-form origin="define/source/pedidos" v-model="currentID"></auto-form>
    </b-col>

    <b-col lg="7" md="6" v-if="currentID">
      <pedidos-detalle v-model="currentID" />
    </b-col>

  </b-row>


</template>

<script>
  import pedidosDetalle from './PedidosDetalleOverview'
  export default {
    components: {pedidosDetalle},
    data(){
      return  {
        currentID: null
      }
    },
    beforeMount(){
      this.currentID = this.$route.params.id
    }
  }
</script>
